<template>
  <v-container>
    <section class="section">
      <h1>FAQ</h1>
      <div v-if="!faqs.length" class="text-center font-weight-regular">
        Chargement des questions les plus fréquemment posées...
      </div>
      <div v-else>
        <Accordion
          :items="faqs"
        >
          <template #content="{item}">
            <div v-html="item.content"></div>
          </template>
        </Accordion>
      </div>
    </section>
  </v-container>
</template>

<script>
import Accordion from '@dzangolab/vue-accordion'
import '@dzangolab/vue-accordion/dist/accordion.css' // import stylesheet
import { mapGetters } from 'vuex'

export default {
  components: {
    Accordion
  },
  computed: {
    ...mapGetters('strapiv2', ['faqs'])
  }
}
</script>